_ = require 'underscore'
assert = require 'app/scripts/lib/assert'
Backgrounds = require 'app/scripts/data/backgrounds'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
{ BoardTemplateBadge } = require 'app/src/components/BoardTemplateBadge'
CardView = require 'app/scripts/views/card/card-view'
Controller = require 'app/scripts/controller'
{ featureFlagClient } = require '@trello/feature-flag-client'
l = require 'app/scripts/lib/localize'
permsTemplate = require 'app/scripts/views/templates/board_header_permissions'
React = require 'react'
ReactDOM = require 'react-dom'
template = require 'app/scripts/views/templates/member_cards_board'
{ trackUe } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'

module.exports = class MemberCardsBoardsSectionView extends View
  className: 'window-module'

  initialize: ({ @cards }) ->
    assert @cards.length > 0

    @makeDebouncedMethods 'renderBoardTemplateBadge'

    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @templateFlagEnabled = newVal
      @renderBoardTemplateBadgeDebounced()

  events: ->
    'click': (e) ->
      if @$(e.target).closest('a').length
        # We clicked on a link, e.g. to the team
        return
      Controller.navigate(Controller.getBoardUrl(@model), { trigger: true })

  trackEvent: (card) =>
    { category, method, context } = @options.trackObj
    enrichedContext = Object.assign({}, context, { boardId: card?.get('idBoard'), cardId: card?.get('id') })

    trackUe(category , 'opens', 'card', '', '', method, enrichedContext)

  isTemplate: ->
    @templateFlagEnabled && @model.isTemplate()

  renderBoardTemplateBadge: ->
    if !@isTemplate()
      if @boardTemplateBadgeDiv
        ReactDOM.unmountComponentAtNode(@boardTemplateBadgeDiv)
        @boardTemplateBadgeDiv = null
        @boardTemplateBadgeComponent = null
      return

    _.defer =>
      @boardTemplateBadgeComponent = React.createElement(BoardTemplateBadge)
      @boardTemplateBadgeDiv = document.createElement('div')
      $(".js-board-template-badge-#{@model.id}").append(@boardTemplateBadgeDiv)
      ReactDOM.render(
        @boardTemplateBadgeComponent,
        @boardTemplateBadgeDiv
      )

  render: ->
    orgData =
      if (org = @model.getOrganization())?
        url: org.get('url')
        name: org.get('displayName')

    lists = _.groupBy @cards, (card) -> card.get('idList')

    @$el.html(template({
      id: @model.id
      name: @model.get('name')
      url: @model.get('url')
      permissionLevel: @model.get('prefs').permissionLevel
      starred: @model.isStarred()
      org: orgData
      lists: @model.listList.chain()
        .filter (list) -> lists[list.id]
        .map (list) ->
          id: list.id
          name: list.get('name')
        .value()
      templateModeEnabled: @isTemplate()
    }))

    $perm = @$('.js-permission-level')
    data =
      permIconClass: BoardDisplayHelpers.getPermLevelIconClassForBoard(@model)
      permText: l(['board perms', @model.getPermLevel(), 'name'])
    $perm.html permsTemplate(data)

    prefs = @model.get('prefs')
    $board = @$('.js-board')

    if prefs.backgroundColor?
      hexcolor = @model.getClientBackgroundColor(prefs.background)

      $board.css
        'background-color': hexcolor

    else
      if Backgrounds.hasOwnProperty(prefs.background)
        # Special handling for our default backgrounds, to avoid using the
        # really huge versions
        url = Util.smallestPreviewBiggerThan(
          prefs.backgroundImageScaled,
          640,
          480
        )?.url ? prefs.backgroundImage
      else
        url = prefs.backgroundImage

      if prefs.backgroundTile
        smallUrl = url
      else
        smallUrl =
          Util.smallestPreviewBiggerThan(
            prefs.backgroundImageScaled
            64
            64
          )?.url ? prefs.backgroundImage


      $board.addClass('body-custom-board-background')

      if prefs.backgroundTile
        $board.addClass('body-custom-board-background-tiled')

      brightness = prefs.backgroundBrightness

      switch brightness
        when 'light'
          $board
          .addClass('body-light-board-background')
        when 'dark'
          $board
          .addClass('body-dark-board-background')

      $board
      .css
        'background-image': "url(\"#{url}\")"

    _.each @$('.js-list'), (el) =>
      $list = @$(el)
      idList = $list.attr('data-idList')

      subviews = _.chain(lists[idList])
        .sortBy (card) -> card.get('pos')
        .map (card) =>
          @subview(CardView, card, { trackApdex: false, trackEvent: @trackEvent.bind(@, card), quickEditHidden: true })
        .value()

      @appendSubviews subviews, $list

    @renderBoardTemplateBadgeDebounced()
    @
